<template>
  <div>
    <div class="toolbar">
      <el-select v-model="projectId" clearable filterable placeholder="项目" style="width:200px" @change="load">
        <el-option v-for="p in projects" :key="p.id" :label="projectLabel(p)" :value="p.id" />
      </el-select>
      <el-select v-model="status" clearable placeholder="审批状态" style="width:130px" @change="load">
        <el-option v-for="o in laborReqStatusFilterOptions" :key="o.value" :label="o.label" :value="o.value" />
      </el-select>
      <el-select v-model="payStatus" clearable placeholder="发放状态" style="width:140px" @change="load">
        <el-option v-for="o in laborPayStatusFilterOptions" :key="o.value" :label="o.label" :value="o.value" />
      </el-select>
      <el-select v-model="confirmStatus" clearable placeholder="确认状态" style="width:140px" @change="load">
        <el-option v-for="o in laborConfirmStatusFilterOptions" :key="o.value" :label="o.label" :value="o.value" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新建申请</el-button>
    </div>

    <el-table :data="pageList" border v-loading="loading">
      <el-table-column prop="reqNo" label="单号" width="160" />
      <el-table-column prop="projectName" label="项目" min-width="140">
        <template slot-scope="{ row }">
          <project-name-link :project-id="row.projectId" :name="row.projectName" />
        </template>
      </el-table-column>
      <el-table-column prop="projectAddress" label="项目地址" min-width="160" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.projectAddress || '-' }}</template>
      </el-table-column>
      <el-table-column prop="stageName" label="工序" width="110" />
      <el-table-column prop="applyTypeName" label="申请类型" width="100" />
      <el-table-column prop="totalAmount" label="金额" width="100" />
      <el-table-column prop="status" label="审批状态" width="100">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="statusType(laborReqStatusMap, row.status)">
            {{ statusLabel(laborReqStatusMap, row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="payStatus" label="发放状态" width="100">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="statusType(laborPayStatusMap, row.payStatus || 'NONE')">
            {{ statusLabel(laborPayStatusMap, row.payStatus || 'NONE') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="confirmStatus" label="确认状态" width="100">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="statusType(laborConfirmStatusMap, row.confirmStatus || 'NONE')">
            {{ statusLabel(laborConfirmStatusMap, row.confirmStatus || 'NONE') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdByName" label="创建人" width="80" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.createdByName || '-' }}</template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="90">
        <template slot-scope="{ row }">{{ formatDateOnly(row.createdAt) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="260" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">详情</el-button>
          <el-button
            type="text"
            :disabled="!canEditRow(row)"
            @click="openEdit(row)"
          >编辑</el-button>
          <el-button
            type="text"
            :disabled="row.status==='APPROVED'
              ? !isPayNone(row)
              : !(row.status==='SUBMITTED' || row.status==='DRAFT')"
            @click="row.status==='APPROVED' ? onUnapprove(row) : onApprove(row)"
          >{{ row.status==='APPROVED' ? '反审' : '审批' }}</el-button>
          <el-button
            type="text"
            class="op-danger"
            :disabled="!(row.status==='SUBMITTED' || row.status==='DRAFT')"
            @click="onReject(row)"
          >驳回</el-button>
          <el-button
            type="text"
            class="op-danger"
            :disabled="!canEditRow(row)"
            @click="onDelete(row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog :title="form.id?'编辑工资申请':'新建工资申请'" :visible.sync="visible" width="980px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="项目" required>
          <el-select v-model="form.projectId" filterable style="width:100%" @change="onProjectChange">
            <el-option v-for="p in projects" :key="p.id" :label="projectLabel(p)" :value="p.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="caps.reqStageRequired" label="工序" required>
          <el-select v-model="form.projectStageId" filterable style="width:100%" placeholder="必选">
            <el-option v-for="s in stages" :key="s.id" :label="s.stageName" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="申请类型" required>
          <el-select v-model="form.applyTypeId" filterable style="width:100%" placeholder="来自字典 工资类型">
            <el-option v-for="d in applyTypes" :key="d.id" :label="d.dictLabel" :value="d.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" /></el-form-item>
        <el-form-item label="明细" required>
          <el-button size="mini" type="primary" plain @click="addLine">添加行</el-button>
          <el-table :data="form.lines" border size="small" style="margin-top:8px">
            <el-table-column label="工人" min-width="140">
              <template slot-scope="{ row }">
                <el-select
                  v-model="row.workerId"
                  filterable
                  style="width:100%"
                  placeholder="必选"
                  @change="onLineWorkerChange(row)"
                >
                  <el-option
                    v-for="w in workers"
                    :key="w.id"
                    :label="w.name + (workerTypeLabel(w) ? (' / ' + workerTypeLabel(w)) : '')"
                    :value="w.id"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="事项" min-width="200">
              <template slot-scope="{ row }">
                <el-select
                  v-model="row.workerPriceItemId"
                  filterable
                  style="width:100%"
                  :disabled="!row.workerId"
                  :placeholder="row.workerId ? (priceOptionsFor(row).length ? '选择价目' : '该工种暂无价目') : '请先选工人'"
                >
                  <el-option
                    v-for="p in priceOptionsFor(row)"
                    :key="p.id"
                    :label="p.itemName + (p.unit ? '（' + p.unit + '）' : '')"
                    :value="p.id"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="单价" width="100" align="right">
              <template slot-scope="{ row }">{{ fmtMoney(linePrice(row)) }}</template>
            </el-table-column>
            <el-table-column label="数量" width="130">
              <template slot-scope="{ row }">
                <el-input-number v-model="row.qty" :min="0.01" :precision="2" size="mini" controls-position="right" />
              </template>
            </el-table-column>
            <el-table-column label="小计" width="110" align="right">
              <template slot-scope="{ row }">{{ fmtMoney(lineAmount(row)) }}</template>
            </el-table-column>
            <el-table-column label="备注" min-width="140">
              <template slot-scope="{ row }">
                <el-input v-model="row.remark" size="mini" maxlength="100" placeholder="选填" />
              </template>
            </el-table-column>
            <el-table-column width="60">
              <template slot-scope="{ $index }">
                <el-button type="text" style="color:#ef4444" @click="form.lines.splice($index,1)">删</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="lines-total">合计：{{ fmtMoney(formTotal) }}</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-drawer title="申请详情" :visible.sync="detailVisible" size="560px">
      <div class="detail-body" v-if="detail">
        <p>单号：{{ detail.req.reqNo }}</p>
        <p>审批：{{ statusLabel(laborReqStatusMap, detail.req.status) }}
          · 发放：{{ statusLabel(laborPayStatusMap, detail.req.payStatus || 'NONE') }}
          · 确认：{{ statusLabel(laborConfirmStatusMap, detail.req.confirmStatus || 'NONE') }}</p>
        <p>项目：{{ detail.req.projectName }} / {{ detail.req.stageName || '-' }}</p>
        <p>申请类型：{{ detail.req.applyTypeName || '-' }}</p>
        <p class="detail-total">合计 {{ fmtMoney(detail.req.totalAmount) }}</p>

        <div
          v-for="g in detailWorkerGroups"
          :key="g.workerId"
          class="worker-block"
        >
          <div class="worker-head">
            <div class="worker-title">
              <span class="worker-name">{{ g.workerName || '-' }}</span>
              <el-tag size="mini" :type="g.paid ? 'success' : 'info'">{{ g.paid ? '已发放' : '未发放' }}</el-tag>
              <el-tag size="mini" :type="g.confirmed ? 'success' : 'info'">{{ g.confirmed ? '已确认' : '未确认' }}</el-tag>
            </div>
            <span class="worker-sum">小计 {{ fmtMoney(g.totalAmount) }}</span>
          </div>
          <el-table :data="g.items" border size="small">
            <el-table-column prop="itemName" label="事项" min-width="120" />
            <el-table-column prop="unit" label="单位" width="60" />
            <el-table-column prop="qty" label="数量" width="70" align="right" />
            <el-table-column prop="price" label="单价" width="80" align="right">
              <template slot-scope="{ row }">{{ fmtMoney(row.price) }}</template>
            </el-table-column>
            <el-table-column prop="amount" label="金额" width="80" align="right">
              <template slot-scope="{ row }">{{ fmtMoney(row.amount) }}</template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip>
              <template slot-scope="{ row }">{{ row.remark || '-' }}</template>
            </el-table-column>
          </el-table>
          <div class="worker-actions">
            <span v-if="g.confirmed" class="pay-meta">
              确认：{{ g.confirmedByName || '-' }} · {{ formatDateTime(g.confirmedAt) }}
            </span>
            <span v-else-if="g.paid" class="pay-meta">
              发放：{{ g.paidByName || '-' }} · {{ formatDateTime(g.paidAt) }}
            </span>
            <el-button
              v-else-if="detail.req.status === 'APPROVED'"
              type="primary"
              size="mini"
              :loading="payingWorkerId === g.workerId"
              @click="onConfirmPay(g)"
            >确认发放</el-button>
            <span v-else class="pay-meta">审批通过后可发放</span>
          </div>
        </div>
        <p v-if="!detailWorkerGroups.length" class="muted">暂无明细</p>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  listLaborReqs, getLaborReq, saveLaborReq,
  approveLaborReq, unapproveLaborReq, rejectLaborReq, confirmLaborPay, deleteLaborReq,
  listWorkers, listWorkerPriceItems
} from '../../api/labor'
import { listProjects, getProject } from '../../api/project'
import { listDictOptions } from '../../api/dict'
import {
  laborReqStatusMap, laborReqStatusFilterOptions,
  laborPayStatusMap, laborPayStatusFilterOptions,
  laborConfirmStatusMap, laborConfirmStatusFilterOptions,
  statusLabel, statusType
} from '../../utils/status'
import ListPagination from '../../components/ListPagination.vue'
import ProjectNameLink from '../../components/ProjectNameLink.vue'
import listPaging from '../../mixins/listPaging'
import { planCapabilities } from '../../utils/plan'
import { mapState } from 'vuex'

export default {
  name: 'LaborRequisition',
  components: { ListPagination, ProjectNameLink },
  mixins: [listPaging],
  data() {
    return {
      laborReqStatusMap,
      laborReqStatusFilterOptions,
      laborPayStatusMap,
      laborPayStatusFilterOptions,
      laborConfirmStatusMap,
      laborConfirmStatusFilterOptions,
      projectId: null, status: '', payStatus: '', confirmStatus: '',
      projects: [], workers: [], priceOptions: [], stages: [], applyTypes: [],
      list: [], loading: false, saving: false,
      visible: false, form: { lines: [] },
      detailVisible: false, detail: null,
      payingWorkerId: null
    }
  },
  created() {
    this.loadMeta()
    const pid = Number(this.$route.query.projectId)
    if (pid) this.projectId = pid
    if (this.$route.query.status) this.status = this.$route.query.status
    if (this.$route.query.payStatus) this.payStatus = this.$route.query.payStatus
    if (this.$route.query.confirmStatus) this.confirmStatus = this.$route.query.confirmStatus
    this.load()
  },
  computed: {
    ...mapState(['user']),
    caps() {
      return planCapabilities(this.user)
    },
    formTotal() {
      const lines = (this.form && this.form.lines) || []
      return lines.reduce((sum, row) => sum + this.lineAmount(row), 0)
    },
    detailWorkerGroups() {
      const lines = (this.detail && this.detail.lines) || []
      const map = new Map()
      for (const l of lines) {
        const wid = l.workerId != null ? l.workerId : 'unknown'
        if (!map.has(wid)) {
          map.set(wid, {
            workerId: wid,
            workerName: l.workerName || '-',
            items: [],
            totalAmount: 0,
            paid: false,
            paidAt: null,
            paidByName: '',
            confirmed: false,
            confirmedAt: null,
            confirmedByName: ''
          })
        }
        const g = map.get(wid)
        if ((!g.workerName || g.workerName === '-') && l.workerName) {
          g.workerName = l.workerName
        }
        g.items.push(l)
        g.totalAmount += Number(l.amount) || 0
        if (l.payStatus === 'PAID') {
          g.paid = true
          g.paidAt = l.paidAt || g.paidAt
          g.paidByName = l.paidByName || g.paidByName
        }
        if (l.confirmStatus === 'CONFIRMED') {
          g.confirmed = true
          g.confirmedAt = l.confirmedAt || g.confirmedAt
          g.confirmedByName = l.confirmedByName || g.confirmedByName
        }
      }
      return Array.from(map.values())
    }
  },
  methods: {
    statusLabel, statusType,
    projectLabel(p) {
      return (p && (p.name || p.customerName)) || ''
    },
    canEditRow(row) {
      return row && (row.status === 'SUBMITTED' || row.status === 'REJECTED' || row.status === 'DRAFT')
    },
    isPayNone(row) {
      const s = (row && row.payStatus) || 'NONE'
      return s === 'NONE'
    },
    fmtMoney(v) {
      const n = Number(v)
      if (Number.isNaN(n)) return '-'
      return n.toFixed(2)
    },
    formatDateTime(v) {
      if (!v) return '-'
      const s = String(v).replace('T', ' ')
      return s.length >= 19 ? s.slice(0, 19) : s
    },
    formatDateOnly(v) {
      if (!v) return '-'
      const s = String(v).replace('T', ' ')
      return s.length >= 10 ? s.slice(0, 10) : s
    },
    async onConfirmPay(g) {
      if (!this.detail || !this.detail.req || !g || g.workerId == null || g.workerId === 'unknown') return
      try {
        await this.$confirm(
          `确认发放工人「${g.workerName || ''}」的工资（小计 ${this.fmtMoney(g.totalAmount)}）？发放后不可撤销。`,
          '确认发放',
          { type: 'warning' }
        )
      } catch (e) {
        return
      }
      this.payingWorkerId = g.workerId
      try {
        const res = await confirmLaborPay(this.detail.req.id, g.workerId)
        this.detail = res.data
        this.$message.success('已确认发放')
        this.load()
      } finally {
        this.payingWorkerId = null
      }
    },
    linePriceItem(row) {
      if (!row || !row.workerPriceItemId) return null
      return (this.priceOptions || []).find(p => p.id === row.workerPriceItemId) || null
    },
    linePrice(row) {
      const p = this.linePriceItem(row)
      if (!p || p.price == null) return 0
      return Number(p.price) || 0
    },
    lineAmount(row) {
      const qty = Number(row && row.qty)
      if (!qty || Number.isNaN(qty)) return 0
      return Math.round(this.linePrice(row) * qty * 100) / 100
    },
    async loadMeta() {
      const [p, w, prices, types] = await Promise.all([
        listProjects({}),
        listWorkers({ enabled: 1 }),
        listWorkerPriceItems({ enabled: 1 }),
        listDictOptions('LABOR_APPLY_TYPE')
      ])
      this.projects = p.data || []
      this.workers = (w.data || []).filter(x => x.enabled !== 0)
      this.priceOptions = prices.data || []
      this.applyTypes = types.data || []
    },
    async load() {
      this.loading = true
      try {
        const res = await listLaborReqs({
          projectId: this.projectId || undefined,
          status: this.status || undefined,
          payStatus: this.payStatus || undefined,
          confirmStatus: this.confirmStatus || undefined
        })
        this.list = res.data || []
        this.page = 1
      } finally { this.loading = false }
    },
    async onProjectChange(id) {
      this.form.projectStageId = null
      if (!id) { this.stages = []; return }
      const res = await getProject(id)
      this.stages = (res.data && res.data.stages) || []
    },
    workerTypeLabel(w) {
      if (!w) return ''
      return w.workTypeName || w.workType || ''
    },
    priceOptionsFor(row) {
      if (!row || !row.workerId) return []
      const w = this.workers.find(x => x.id === row.workerId)
      const typeIds = this.workerTypeIds(w)
      if (!typeIds.length) return []
      return (this.priceOptions || []).filter(p => typeIds.includes(p.workerTypeId))
    },
    workerTypeIds(w) {
      if (!w) return []
      if (Array.isArray(w.workTypeIdList) && w.workTypeIdList.length) return w.workTypeIdList
      if (w.workTypeIds) {
        return w.workTypeIds.split(',').map(x => Number(String(x).trim())).filter(x => x)
      }
      return []
    },
    onLineWorkerChange(row) {
      row.workerPriceItemId = null
    },
    addLine() {
      this.form.lines.push({ workerPriceItemId: null, qty: 1, workerId: null, remark: '' })
    },
    async openEdit(row) {
      await this.loadMeta()
      if (!row) {
        this.form = {
          id: null,
          projectId: null,
          projectStageId: null,
          applyTypeId: null,
          remark: '',
          lines: []
        }
        this.stages = []
        this.addLine()
        this.visible = true
        return
      }
      const res = await getLaborReq(row.id)
      const d = res.data || {}
      const r = d.req || {}
      this.form = {
        id: r.id,
        projectId: r.projectId,
        projectStageId: r.projectStageId,
        applyTypeId: r.applyTypeId,
        remark: r.remark,
        lines: (d.lines || []).map(l => ({
          workerPriceItemId: l.workerPriceItemId,
          qty: Number(l.qty),
          workerId: l.workerId,
          remark: l.remark || ''
        }))
      }
      await this.onProjectChange(r.projectId)
      this.form.projectStageId = r.projectStageId
      this.visible = true
    },
    async openDetail(row) {
      const res = await getLaborReq(row.id)
      this.detail = res.data
      this.detailVisible = true
    },
    async save() {
      const f = this.form
      if (!f.projectId) return this.$message.warning('请选择项目')
      if (this.caps.reqStageRequired && !f.projectStageId) return this.$message.warning('请选择工序')
      if (!f.applyTypeId) return this.$message.warning('请选择申请类型')
      if (!f.lines.length || f.lines.some(l => !l.workerId || !l.workerPriceItemId || !l.qty)) {
        return this.$message.warning('请完善明细（工人、事项、数量）')
      }
      this.saving = true
      try {
        await saveLaborReq(f)
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } finally { this.saving = false }
    },
    onApprove(row) {
      this.$confirm('审批通过？').then(async () => {
        await approveLaborReq(row.id); this.$message.success('已审批'); this.load()
      }).catch(() => {})
    },
    onUnapprove(row) {
      if (!this.isPayNone(row)) {
        return this.$message.warning('已有发放记录，不可反审')
      }
      this.$confirm('反审后将变回待审批，是否继续？', '反审', { type: 'warning' }).then(async () => {
        await unapproveLaborReq(row.id)
        this.$message.success('已反审')
        this.load()
      }).catch(() => {})
    },
    onReject(row) {
      this.$prompt('驳回原因', '驳回', { inputPattern: /\S+/, inputErrorMessage: '请填写原因' })
        .then(async ({ value }) => {
          await rejectLaborReq(row.id, value)
          this.$message.success('已驳回')
          this.load()
        }).catch(() => {})
    },
    onDelete(row) {
      this.$confirm('确认删除该申请？', '提示', { type: 'warning' }).then(async () => {
        await deleteLaborReq(row.id); this.$message.success('已删除'); this.load()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.tip { margin:0 0 10px; color:#64748b; font-size:13px; }
.lines-total {
  margin-top: 10px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}
.detail-body { padding: 0 16px 16px; }
.detail-total { font-weight: 600; color: #0f172a; }
.worker-block {
  margin-top: 14px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}
.worker-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 12px;
}
.worker-name { font-weight: 600; font-size: 14px; color: #0f172a; }
.worker-title { display: flex; align-items: center; gap: 8px; min-width: 0; }
.worker-sum { color: #2563eb; font-weight: 600; font-size: 13px; flex-shrink: 0; }
.worker-actions {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.pay-meta { color: #64748b; font-size: 12px; }
.muted { color: #94a3b8; margin-top: 12px; }
</style>
